import angular from 'angular'
import angularMoment from 'angular-moment'

import { formatDuration } from 'common/clock'

export default angular.module('ljungmann.filters.duration', [
  angularMoment
])
  // The arithmetic is in common/clock.js, because the Compose sentences write
  // the same lengths in text and the two must agree.
  .filter('duration', function () {
    'ngInject'

    return formatDuration
  })
  .name
